import { render, staticRenderFns } from "./BarDiagram.vue?vue&type=template&id=565f84f9&scoped=true&"
import script from "./BarDiagram.vue?vue&type=script&lang=js&"
export * from "./BarDiagram.vue?vue&type=script&lang=js&"
import style0 from "./BarDiagram.vue?vue&type=style&index=0&id=565f84f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f84f9",
  null
  
)

component.options.__file = "BarDiagram.vue"
export default component.exports